<template>
  <img
    src="http://obs3.justtool.com/images/kefu.png"
    class="kefuimg"
    @click="showBot"
  />
</template>

<script>
import { initChat } from '@/utils/cozechat'

export default {
  name: 'CozeChat',
  data() {
    return {
      codesdk: null,
    }
  },
  mounted() {
    // 动态加载 Coze SDK
    this.loadCozeSDK()
  },
  methods: {
    // 加载 Coze SDK
    loadCozeSDK() {
      const script = document.createElement('script')
      script.src =
        'https://lf-cdn.coze.cn/obj/unpkg/flow-platform/chat-app-sdk/1.1.0-beta.1/libs/cn/index.js' // 替换为 Coze 提供的 SDK URL
      script.async = true
      script.onload = () => {
        // 初始化 Coze SDK
        const cozeWeb = initChat(this.$root.COZEID)
        this.codesdk = cozeWeb
      }
      document.head.appendChild(script)
    },

    showBot() {
      this.codesdk.showChatBot()
    },
  },
}
</script>

<style>
.kefuimg {
  position: fixed;
  width: 90px;
  height: 90px;
  right: 20px;
  bottom: 50px;
  cursor: pointer;
}
</style>


